import './styles.scss'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import English from './English'
import German from './German'
import { useDispatch, useSelector } from 'react-redux'
import { changeLanguageAction, languageSelector } from '../../../redux/features/language/languageSlice'

const LanguageChanger = () => {
  const { i18n } = useTranslation()
  const selectedLanguage = useSelector(languageSelector)
  const dispatch = useDispatch()
  const [isDropdownVisible, setDropdownVisible] = useState(false)

  const changeLanguage = (isoCode) => {
    dispatch(changeLanguageAction(isoCode))
    i18n.changeLanguage(isoCode)
  }

  const languageElements = {
    'de': <German onClick={() => changeLanguage('de')}/>,
    'en': <English onClick={() => changeLanguage('en')}/>,
  }

  const calculateDropDownElements = () => {
    return Object.keys(languageElements).filter((isoCode) => isoCode !== selectedLanguage.isoCode) // Exclude the active language
      .map((isoCode) => {
        return (
          <li key={isoCode} className={'language-item'}>
            {languageElements[isoCode]}
          </li>
        )
      })
  }

  useEffect(() => {
    changeLanguage(selectedLanguage.isoCode) // Set default language to the selected language code
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // The empty dependency array ensures it runs only on mount

  return (
    <div className="language-changer"
         onMouseEnter={() => {setDropdownVisible(true)}}
         onMouseLeave={() => {setDropdownVisible(false)}}>
      <div className={'language-item active-language-item'}>
        {languageElements[selectedLanguage.isoCode]}
      </div>
      {isDropdownVisible && (
        <ul className="dropdown">
          {calculateDropDownElements()}
        </ul>
      )}
    </div>
  )
}

export default LanguageChanger
